/* Nordbelt concept v8 — Aurora / Scroll Cinema
   Volledig lokaal: geen Shopify, geen checkout, geen netwerk-mutaties. */
(() => {
  "use strict";

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const supportsColorMix = window.CSS && CSS.supports("color", "color-mix(in oklab, red 50%, blue)");

  /* ---------- intro curtain ---------- */
  const intro = $("[data-intro]");
  if (intro) {
    if (reduceMotion || sessionStorage.getItem("nb8-intro")) {
      intro.classList.add("is-off");
    } else {
      requestAnimationFrame(() => intro.classList.add("is-loading"));
      window.setTimeout(() => {
        intro.classList.add("is-done");
        sessionStorage.setItem("nb8-intro", "1");
        window.setTimeout(() => intro.classList.add("is-off"), 800);
      }, 1050);
    }
  }

  /* ---------- header ---------- */
  const header = $("[data-header]");
  const onScrollHeader = () => header.classList.toggle("is-scrolled", window.scrollY > 10);
  onScrollHeader();
  window.addEventListener("scroll", onScrollHeader, { passive: true });

  /* ---------- mobiel menu ---------- */
  const menu = $("[data-menu]");
  const menuBtn = $("[data-menu-btn]");
  const setMenu = (open) => {
    menu.hidden = !open;
    menuBtn.setAttribute("aria-expanded", String(open));
    document.body.style.overflow = open ? "hidden" : "";
  };
  menuBtn.addEventListener("click", () => setMenu(menu.hidden));
  $$("[data-menu-link]").forEach((a) => a.addEventListener("click", () => setMenu(false)));

  /* ---------- reveal on scroll ---------- */
  const revealEls = $$(".reveal");
  if (reduceMotion) {
    revealEls.forEach((el) => el.classList.add("is-in"));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
    );
    revealEls.forEach((el) => io.observe(el));
  }

  /* ---------- tellers ---------- */
  const counters = $$("[data-count]");
  const runCounter = (el) => {
    const target = Number(el.dataset.count);
    const suffix = el.dataset.suffix || "";
    if (reduceMotion) {
      el.textContent = target + suffix;
      return;
    }
    const t0 = performance.now();
    const dur = 1100;
    const tick = (t) => {
      const p = clamp((t - t0) / dur, 0, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  if (counters.length) {
    const cio = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            runCounter(e.target);
            cio.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach((el) => cio.observe(el));
  }

  /* ---------- de Nordic curl ----------
     Renderer 1-op-1 geport van de live nordbelt.nl-homepage (canvas-animatie);
     kleuren omgezet naar het poolnacht-palet van deze sectie.
     Loopt autonoom (6,4s-cyclus, zoals op de site) zodra hij in beeld is. */
  const move = $("[data-move]");
  if (move) {
    const canvas = $("[data-nhc-canvas]", move);
    const ctx = canvas ? canvas.getContext("2d", { alpha: true }) : null;
    const loadEl = $("[data-curl-load]", move);
    const barEl = $("[data-curl-bar]", move);
    const phases = $$(".move__phases li", move);

    if (canvas && ctx) {
      // — geometrie & timing: overgenomen van nordbelt.nl —
      const DESIGN_W = 800;
      const DESIGN_H = 486;
      const TORSO_WIDTH = 30, THIGH_WIDTH = 25, SHIN_WIDTH = 21;
      const UPPER_ARM_WIDTH = 16, FOREARM_WIDTH = 13;
      const SHIN_LEN = 158, FOOT_LEN = 34, THIGH_LEN = 152, TORSO_LEN = 175;
      const UPPER_ARM_LEN = 92, FOREARM_LEN = 63;
      const KNEE_X = 270, GROUND_Y = 448, KNEE_Y = GROUND_Y;
      const TOP_ANGLE = (115 * Math.PI) / 180;
      const BOTTOM_ANGLE = (18 * Math.PI) / 180;
      const RANGE = TOP_ANGLE - BOTTOM_ANGLE;
      const ECCENTRIC_FRAC = 0.75;
      const REST_FRAC = 0.3;
      const REST_TORSO_WORLD = (87 * Math.PI) / 180;
      const BOTTOM_TORSO_WORLD = (-1 * Math.PI) / 180;

      // — palet: zacht ijs + kalm cobalt; canvas zelf is transparant —
      const BODY_COLOR = "#d9e4f2";
      const SHIRT_COLOR = "#4a63d8";
      const SHORTS_COLOR = "#31418f";
      const SHOE_COLOR = "#b6c7dc";
      const GLOW_RGB = "74, 99, 216";
      const GLOW_SOFT_RGB = "150, 200, 235";
      const CYCLE_MS = 6400;

      const noiseConfig = {
        thigh: { freq: 1.7, phase: 0.0, amp: 0.01 },
        torso: { freq: 2.3, phase: 1.1, amp: 0.014 },
        head: { freq: 3.1, phase: 2.5, amp: 0.02 },
        arm: { freq: 2.0, phase: 0.7, amp: 0.012 },
      };

      let dpr = 1;
      let scale = 1;

      const smootherStep = (t) => {
        t = clamp(t, 0, 1);
        return t * t * t * (t * (t * 6 - 15) + 10);
      };
      const eccentricEase = (t) => 1 - Math.pow(1 - t, 3.5);
      const getNoise = (name, timeSec) => {
        const cfg = noiseConfig[name];
        return Math.sin(timeSec * cfg.freq * Math.PI * 2 + cfg.phase) * cfg.amp;
      };

      const getThighAngle = (cycleT) => {
        if (cycleT < REST_FRAC) return TOP_ANGLE;
        const activeT = (cycleT - REST_FRAC) / (1 - REST_FRAC);
        if (activeT < ECCENTRIC_FRAC) {
          return TOP_ANGLE - RANGE * eccentricEase(activeT / ECCENTRIC_FRAC);
        }
        const concentric = (activeT - ECCENTRIC_FRAC) / (1 - ECCENTRIC_FRAC);
        return BOTTOM_ANGLE + RANGE * smootherStep(concentric);
      };

      const getTorsoRel = (thighAngle) => {
        const progress = 1 - (thighAngle - BOTTOM_ANGLE) / RANGE;
        const restRel = TOP_ANGLE - REST_TORSO_WORLD;
        const bottomRel = BOTTOM_ANGLE - BOTTOM_TORSO_WORLD;
        return restRel + progress * progress * (bottomRel - restRel);
      };

      const drawLine = (x1, y1, x2, y2) => {
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
      };
      const drawLimb = (x1, y1, x2, y2, width) => {
        ctx.save();
        ctx.lineWidth = width * scale;
        ctx.lineCap = "round";
        drawLine(x1, y1, x2, y2);
        ctx.restore();
      };
      const drawJoint = (x, y, radius) => {
        ctx.beginPath();
        ctx.arc(x, y, radius * scale, 0, Math.PI * 2);
        ctx.fill();
      };
      const drawLimbHighlight = (x1, y1, x2, y2, width) => {
        const limbWidth = width * scale;
        const dx = x2 - x1;
        const dy = y2 - y1;
        const len = Math.sqrt(dx * dx + dy * dy);
        if (len < 1) return;
        const ox = (-dy / len) * limbWidth * 0.22;
        const oy = (dx / len) * limbWidth * 0.22;
        ctx.save();
        ctx.strokeStyle = "rgba(255, 255, 255, 0.24)";
        ctx.lineWidth = limbWidth * 0.3;
        ctx.lineCap = "round";
        drawLine(x1 + ox, y1 + oy, x2 + ox, y2 + oy);
        ctx.restore();
      };

      const drawHead = (shoulderX, shoulderY, angle) => {
        const radius = 31 * scale;
        const cx = shoulderX + Math.cos(angle) * radius;
        const cy = shoulderY - Math.sin(angle) * radius;
        ctx.save();
        ctx.fillStyle = BODY_COLOR;
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = "#93aecb";
        ctx.beginPath();
        ctx.arc(cx, cy, radius * 0.66, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = SHIRT_COLOR;
        ctx.beginPath();
        ctx.arc(cx, cy, radius * 1.06, -angle + Math.PI * 0.5, -angle - Math.PI * 0.5, false);
        ctx.arc(cx, cy, radius * 0.7, -angle - Math.PI * 0.5, -angle + Math.PI * 0.5, true);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      };

      const drawShoe = (ankleX, ankleY, groundY) => {
        ctx.save();
        ctx.strokeStyle = SHOE_COLOR;
        ctx.lineWidth = 24 * scale;
        ctx.lineCap = "round";
        drawLine(ankleX, ankleY, ankleX, groundY - 1.5 * scale);
        ctx.restore();
      };

      const drawBackground = (timeSec) => {
        const gradient = ctx.createLinearGradient(0, 0, canvas.width * 0.2, canvas.height);
        gradient.addColorStop(0, "#101d33");
        gradient.addColorStop(0.55, "#0c1626");
        gradient.addColorStop(1, "#0a1322");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const glowA = ctx.createRadialGradient(canvas.width * 0.12, canvas.height * 0.11, 0, canvas.width * 0.12, canvas.height * 0.11, canvas.width * 0.62);
        glowA.addColorStop(0, "rgba(165, 233, 255, 0.10)");
        glowA.addColorStop(0.55, "rgba(165, 233, 255, 0.03)");
        glowA.addColorStop(1, "rgba(165, 233, 255, 0)");
        ctx.fillStyle = glowA;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const pulse = 0.5 + Math.sin(timeSec * 0.65) * 0.5;
        const glowB = ctx.createRadialGradient(canvas.width * 0.83, canvas.height * 0.18, 0, canvas.width * 0.83, canvas.height * 0.18, canvas.width * 0.48);
        glowB.addColorStop(0, "rgba(" + GLOW_RGB + ", " + (0.20 + pulse * 0.07) + ")");
        glowB.addColorStop(1, "rgba(" + GLOW_RGB + ", 0)");
        ctx.fillStyle = glowB;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      };

      const drawGround = (groundY) => {
        const s = scale;
        const floorFill = ctx.createLinearGradient(0, groundY, 0, canvas.height);
        floorFill.addColorStop(0, "rgba(165, 233, 255, 0.07)");
        floorFill.addColorStop(1, "rgba(165, 233, 255, 0.02)");
        ctx.fillStyle = floorFill;
        ctx.fillRect(0, groundY, canvas.width, canvas.height - groundY);
        ctx.strokeStyle = "rgba(165, 233, 255, 0.4)";
        ctx.lineWidth = 2 * s;
        drawLine(18 * s, groundY, canvas.width - 18 * s, groundY);
        ctx.strokeStyle = "rgba(255, 255, 255, 0.08)";
        ctx.lineWidth = 1 * s;
        drawLine(18 * s, groundY - 1.5 * s, canvas.width - 18 * s, groundY - 1.5 * s);
      };

      const computePose = (thighBase, timeSec) => {
        const s = scale;
        const kneeX = KNEE_X * s;
        const kneeY = KNEE_Y * s;
        const groundY = GROUND_Y * s;

        const thighA = thighBase + getNoise("thigh", timeSec);
        const torsoRel = getTorsoRel(thighA) + getNoise("torso", timeSec);
        const torsoWorld = thighA - torsoRel;

        const shinAngle = Math.PI - Math.asin(FOOT_LEN / SHIN_LEN);
        const ankleX = kneeX + Math.cos(shinAngle) * SHIN_LEN * s;
        const ankleY = kneeY - Math.sin(shinAngle) * SHIN_LEN * s;

        const hipX = kneeX + Math.cos(thighA) * THIGH_LEN * s;
        const hipY = kneeY - Math.sin(thighA) * THIGH_LEN * s;

        const shoulderX = hipX + Math.cos(torsoWorld) * TORSO_LEN * s;
        const shoulderY = hipY - Math.sin(torsoWorld) * TORSO_LEN * s;

        const armAttachX = shoulderX + (hipX - shoulderX) * 0.2;
        const armAttachY = shoulderY + (hipY - shoulderY) * 0.2;
        const armAngle = torsoWorld + Math.PI + (25 * Math.PI) / 180 + getNoise("arm", timeSec);
        let elbowX = armAttachX + Math.cos(armAngle) * UPPER_ARM_LEN * s;
        let elbowY = armAttachY - Math.sin(armAngle) * UPPER_ARM_LEN * s;
        const tilt = clamp(torsoWorld / (Math.PI / 2), 0, 1);
        const elbowBend = (170 * Math.PI) / 180 + tilt * (Math.PI / 2 - (170 * Math.PI) / 180);
        const forearmAngle = armAngle + elbowBend;
        let wristX = elbowX + Math.cos(forearmAngle) * FOREARM_LEN * s;
        let wristY = elbowY - Math.sin(forearmAngle) * FOREARM_LEN * s;
        if (elbowY > groundY) elbowY = groundY;
        if (wristY > groundY) wristY = groundY;

        return {
          kneeX, kneeY, ankleX, ankleY, hipX, hipY,
          shoulderX, shoulderY, armAttachX, armAttachY,
          elbowX, elbowY, wristX, wristY, torsoWorld,
          headNoise: getNoise("head", timeSec), groundY,
        };
      };

      const drawFigureShadow = (pose) => {
        const spread = Math.abs(pose.shoulderX - pose.ankleX) + 42 * scale;
        const centerX = (pose.kneeX + pose.shoulderX) / 2;
        const gradient = ctx.createRadialGradient(centerX, pose.groundY + 1.5 * scale, 0, centerX, pose.groundY + 1.5 * scale, spread / 2);
        gradient.addColorStop(0, "rgba(74, 99, 216, 0.22)");
        gradient.addColorStop(0.6, "rgba(74, 99, 216, 0.09)");
        gradient.addColorStop(1, "rgba(74, 99, 216, 0)");
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.ellipse(centerX, pose.groundY + 1.5 * scale, spread / 2, 8 * scale, 0, 0, Math.PI * 2);
        ctx.fill();
      };

      const drawFigure = (pose, timeSec, eccProgress) => {
        drawFigureShadow(pose);

        if (eccProgress > 0.01 && eccProgress < 1) {
          const pulse = 0.5 + 0.5 * Math.sin(timeSec * 6.2);
          const ramp = Math.min(1, eccProgress * 3.9);
          const fade = 1 - Math.pow(Math.max(0, eccProgress - 0.9) / 0.1, 2);
          const intensity = ramp * fade * (0.84 + 0.34 * pulse);
          ctx.save();
          ctx.strokeStyle = "rgba(" + GLOW_RGB + ", " + intensity * 0.7 + ")";
          ctx.shadowColor = "rgba(" + GLOW_RGB + ", " + intensity * 0.42 + ")";
          ctx.shadowBlur = (24 + 22 * intensity) * scale;
          ctx.lineWidth = (THIGH_WIDTH + 44) * scale;
          ctx.lineCap = "round";
          drawLine(pose.kneeX, pose.kneeY, pose.hipX, pose.hipY);
          ctx.restore();

          ctx.save();
          ctx.strokeStyle = "rgba(" + GLOW_SOFT_RGB + ", " + intensity * 0.4 + ")";
          ctx.lineWidth = (THIGH_WIDTH + 27) * scale;
          ctx.lineCap = "round";
          drawLine(pose.kneeX, pose.kneeY, pose.hipX, pose.hipY);
          ctx.restore();

          ctx.save();
          ctx.strokeStyle = "rgba(255, 122, 100, " + intensity * 0.24 + ")";
          ctx.lineWidth = (THIGH_WIDTH + 10) * scale;
          ctx.lineCap = "round";
          drawLine(pose.kneeX, pose.kneeY, pose.hipX, pose.hipY);
          ctx.restore();
        }

        ctx.strokeStyle = BODY_COLOR;
        ctx.fillStyle = BODY_COLOR;
        drawLimb(pose.kneeX, pose.kneeY, pose.ankleX, pose.ankleY, SHIN_WIDTH);
        drawJoint(pose.ankleX, pose.ankleY, SHIN_WIDTH / 2);
        drawShoe(pose.ankleX, pose.ankleY, pose.groundY);

        ctx.strokeStyle = SHORTS_COLOR;
        ctx.fillStyle = SHORTS_COLOR;
        drawLimb(pose.kneeX, pose.kneeY, pose.hipX, pose.hipY, THIGH_WIDTH);
        drawJoint(pose.kneeX, pose.kneeY, THIGH_WIDTH / 2);
        drawJoint(pose.hipX, pose.hipY, THIGH_WIDTH / 2);

        ctx.strokeStyle = SHIRT_COLOR;
        ctx.fillStyle = SHIRT_COLOR;
        drawLimb(pose.hipX, pose.hipY, pose.shoulderX, pose.shoulderY, TORSO_WIDTH);

        ctx.strokeStyle = BODY_COLOR;
        ctx.fillStyle = BODY_COLOR;
        drawLimb(pose.armAttachX, pose.armAttachY, pose.elbowX, pose.elbowY, UPPER_ARM_WIDTH);
        drawJoint(pose.elbowX, pose.elbowY, UPPER_ARM_WIDTH / 2);
        drawLimb(pose.elbowX, pose.elbowY, pose.wristX, pose.wristY, FOREARM_WIDTH);

        ctx.save();
        ctx.strokeStyle = "#d6e7f8";
        ctx.lineWidth = 20 * scale;
        ctx.lineCap = "round";
        drawLine(pose.wristX, pose.wristY, pose.wristX, pose.wristY + 1 * scale);
        ctx.restore();

        drawLimbHighlight(pose.kneeX, pose.kneeY, pose.ankleX, pose.ankleY, SHIN_WIDTH);
        drawLimbHighlight(pose.kneeX, pose.kneeY, pose.hipX, pose.hipY, THIGH_WIDTH);
        drawLimbHighlight(pose.hipX, pose.hipY, pose.shoulderX, pose.shoulderY, TORSO_WIDTH);
        drawLimbHighlight(pose.armAttachX, pose.armAttachY, pose.elbowX, pose.elbowY, UPPER_ARM_WIDTH);

        drawHead(pose.shoulderX, pose.shoulderY, pose.torsoWorld + pose.headNoise);
      };

      const drawHud = (progress, repCount) => {
        const s = scale;
        const ringRadius = 62 * s;
        const ringWidth = 11 * s;
        const centerX = canvas.width - 86 * s;
        const centerY = 78 * s;
        const outerRadius = ringRadius + 10 * s;
        const startAngle = -Math.PI / 2;
        const endAngle = startAngle + Math.PI * 2 * progress;

        ctx.save();
        const glow = ctx.createRadialGradient(centerX, centerY, ringRadius * 0.15, centerX, centerY, ringRadius * 1.5);
        glow.addColorStop(0, "rgba(165, 233, 255, 0.14)");
        glow.addColorStop(1, "rgba(165, 233, 255, 0)");
        ctx.fillStyle = glow;
        ctx.beginPath();
        ctx.arc(centerX, centerY, ringRadius * 1.52, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = "rgba(10, 19, 34, 0.85)";
        ctx.strokeStyle = "rgba(165, 233, 255, 0.28)";
        ctx.lineWidth = 1.1 * s;
        ctx.beginPath();
        ctx.arc(centerX, centerY, outerRadius, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();

        ctx.strokeStyle = "rgba(165, 233, 255, 0.16)";
        ctx.lineWidth = ringWidth;
        ctx.lineCap = "round";
        ctx.beginPath();
        ctx.arc(centerX, centerY, ringRadius, startAngle, startAngle + Math.PI * 2);
        ctx.stroke();

        ctx.strokeStyle = progress > 0.985 ? "#ff9a82" : "#96c8eb";
        ctx.beginPath();
        ctx.arc(centerX, centerY, ringRadius, startAngle, endAngle);
        ctx.stroke();

        const centerFill = ctx.createLinearGradient(centerX, centerY - ringRadius, centerX, centerY + ringRadius);
        centerFill.addColorStop(0, "#101d33");
        centerFill.addColorStop(1, "#0a1322");
        ctx.fillStyle = centerFill;
        ctx.beginPath();
        ctx.arc(centerX, centerY, ringRadius - ringWidth * 0.92, 0, Math.PI * 2);
        ctx.fill();

        const digits = String(repCount);
        const numberSize = digits.length > 2 ? 26 * s : 34 * s;
        ctx.fillStyle = "#dce7f5";
        ctx.font = "800 " + numberSize + 'px "Bricolage Grotesque", "Avenir Next", sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(digits, centerX, centerY - 3 * s);

        ctx.font = "600 " + 14 * s + 'px "JetBrains Mono", monospace';
        ctx.fillStyle = "rgba(202, 222, 244, 0.65)";
        ctx.fillText("reps", centerX, centerY + 21 * s);
        ctx.restore();
      };

      const renderFrame = (cycleT, timeSec, repCount) => {
        if (!canvas.width || !canvas.height) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const pose = computePose(getThighAngle(cycleT), timeSec);
        drawGround(pose.groundY);
        const activeT = cycleT < REST_FRAC ? 0 : (cycleT - REST_FRAC) / (1 - REST_FRAC);
        const eccProgress = activeT > 0 && activeT < ECCENTRIC_FRAC ? activeT / ECCENTRIC_FRAC : 0;
        drawFigure(pose, timeSec, eccProgress);
        drawHud(clamp(activeT, 0, 1), repCount);
      };

      const resizeCanvas = () => {
        // CSS (width:100% + aspect-ratio) bepaalt de layout; hier alleen de bitmapresolutie
        const cssWidth = canvas.getBoundingClientRect().width || DESIGN_W;
        if (cssWidth <= 0) return;
        dpr = Math.max(1, window.devicePixelRatio || 1);
        canvas.width = Math.round(cssWidth * dpr);
        canvas.height = Math.round(((cssWidth * DESIGN_H) / DESIGN_W) * dpr);
        scale = Math.min(canvas.width / DESIGN_W, canvas.height / DESIGN_H);
      };

      // — autonome tijdlijn (zoals op de site) + live telemetrie —
      let elapsed = 0;
      let lastFrameTime = 0;
      let lastCycleT = REST_FRAC;
      let active = false;
      let rafId = null;
      let reps = 0;

      const countRep = () => { reps += 1; };

      const telemetry = (cycleT) => {
        const thighA = getThighAngle(cycleT);
        const lean = ((TOP_ANGLE - thighA) / RANGE) * 78;
        const load = 20 + (lean / 78) * 80;
        loadEl.textContent = `${Math.round(load)}%`;
        barEl.style.width = `${load}%`;
        const activeT = cycleT < REST_FRAC ? 0 : (cycleT - REST_FRAC) / (1 - REST_FRAC);
        const phase = cycleT < REST_FRAC + 0.06 ? 0 : activeT < ECCENTRIC_FRAC ? 1 : 2;
        phases.forEach((li, i) => li.classList.toggle("is-active", i === phase));
      };

      const frame = (now) => {
        if (!lastFrameTime) lastFrameTime = now;
        let delta = now - lastFrameTime;
        if (!isFinite(delta) || delta < 0) delta = 0;
        if (delta > 120) delta = 120;
        elapsed += delta;
        lastFrameTime = now;
        const completed = Math.floor(elapsed / CYCLE_MS);
        if (completed > reps) countRep();
        lastCycleT = (elapsed % CYCLE_MS) / CYCLE_MS;
        renderFrame(lastCycleT, elapsed / 1000, reps);
        telemetry(lastCycleT);
        rafId = active ? requestAnimationFrame(frame) : null;
      };

      resizeCanvas();
      if ("ResizeObserver" in window) {
        new ResizeObserver(() => {
          resizeCanvas();
          if (!active) {
            renderFrame(lastCycleT, elapsed / 1000, reps);
            telemetry(lastCycleT);
          }
        }).observe(canvas.parentElement);
      }

      if (reduceMotion) {
        renderFrame(REST_FRAC, 0, 0);
        telemetry(REST_FRAC);
      } else {
        const mio = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              active = e.isIntersecting;
              if (active && rafId === null) {
                lastFrameTime = 0; // geen tijdsprong na uit beeld
                rafId = requestAnimationFrame(frame);
              }
            });
          },
          { threshold: 0.12 }
        );
        mio.observe(move);
        renderFrame(REST_FRAC, 0, 0);
        telemetry(REST_FRAC);
      }
    }
  }

  /* ---------- video's: toggle + autoplay in beeld ---------- */
  $$("[data-video-card]").forEach((card) => {
    const video = $("video", card);
    const btn = $("[data-video-toggle]", card);
    if (!video || !btn) return;
    const toggle = () => {
      if (video.paused) {
        video.dataset.userPaused = "";
        video.play().catch(() => {});
      } else {
        video.dataset.userPaused = "1";
        video.pause();
      }
    };
    btn.addEventListener("click", toggle);
    video.addEventListener("click", toggle);
    video.addEventListener("play", () => card.classList.add("is-playing"));
    video.addEventListener("pause", () => card.classList.remove("is-playing"));
  });

  // autoplay zodra ± 40% in beeld, pauzeer buiten beeld (tenzij de gebruiker zelf pauzeerde)
  const vio = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        const video = e.target;
        const auto = video.closest("[data-autoplay]");
        const inSequence = video.closest("[data-sequence]");
        if (e.isIntersecting) {
          if (auto && !inSequence && !reduceMotion && video.paused && video.dataset.userPaused !== "1") {
            video.play().catch(() => {});
          }
        } else if (!video.paused && !inSequence) {
          video.pause();
        }
      });
    },
    { threshold: 0.4 }
  );
  $$("video").forEach((v) => vio.observe(v));

  /* ---------- stappenvideo's: automatisch ná elkaar ---------- */
  const seq = $("[data-sequence]");
  if (seq) {
    const seqCards = $$("[data-video-card]", seq);
    const seqVids = seqCards.map((c) => $("video", c));
    let seqIdx = 0;
    let seqActive = false;
    const seqInView = () => {
      const r = seq.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    };
    const seqMark = (i) => {
      seqIdx = i;
      seqCards.forEach((c, j) => c.classList.toggle("is-current", j === i));
      // mobiel: horizontale scroller volgt de spelende video
      if (seq.scrollWidth > seq.clientWidth + 8) {
        const cardRect = seqCards[i].getBoundingClientRect();
        const seqRect = seq.getBoundingClientRect();
        seq.scrollTo({
          left: Math.max(0, seq.scrollLeft + (cardRect.left - seqRect.left) - 18),
          behavior: reduceMotion ? "auto" : "smooth",
        });
      }
    };
    const seqPlay = (i, restart) => {
      seqMark(i);
      seqVids.forEach((v, j) => { if (j !== i && !v.paused) v.pause(); });
      const v = seqVids[i];
      if (restart || v.ended) v.currentTime = 0;
      v.play().catch(() => {});
    };
    seqVids.forEach((v, i) => {
      v.addEventListener("ended", () => {
        if (!reduceMotion && seqInView()) seqPlay((i + 1) % seqVids.length, true);
        // toon na afloop weer het beginbeeld (poster) i.p.v. het laatste frame
        window.setTimeout(() => {
          if (v.ended) {
            try { v.load(); } catch (e) { /* geen probleem */ }
          }
        }, 80);
      });
      v.addEventListener("play", () => seqMark(i));
    });
    if (!reduceMotion) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            seqActive = e.isIntersecting;
            if (seqActive) {
              if (seqVids[seqIdx].paused) seqPlay(seqIdx, false);
            } else {
              seqVids.forEach((v) => { if (!v.paused) v.pause(); });
            }
          });
        },
        { threshold: 0.35 }
      ).observe(seq);
    }
  }

  /* ---------- uitlegvideo: geluid aan/uit ---------- */
  const soundBtn = $("[data-sound]");
  const flowVideo = $("[data-flow-video]");
  if (soundBtn && flowVideo) {
    soundBtn.addEventListener("click", () => {
      flowVideo.muted = !flowVideo.muted;
      const on = !flowVideo.muted;
      soundBtn.setAttribute("aria-pressed", String(on));
      soundBtn.innerHTML = on
        ? '<i aria-hidden="true">🔊</i> Geluid uit'
        : '<i aria-hidden="true">🔇</i> Geluid aan';
      if (on && flowVideo.paused) flowVideo.play().catch(() => {});
    });
  }

  /* ---------- hero: tilt op de telefoon ---------- */
  const stage = $("[data-tilt]");
  const phone = stage ? $(".phone", stage) : null;
  if (stage && phone && !reduceMotion && window.matchMedia("(pointer: fine)").matches) {
    stage.addEventListener("pointermove", (e) => {
      const r = stage.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      phone.style.transform = `rotate(2deg) rotateY(${(x * 10).toFixed(2)}deg) rotateX(${(-y * 8).toFixed(2)}deg)`;
    });
    stage.addEventListener("pointerleave", () => {
      phone.style.transform = "";
    });
  }

  /* ---------- train overal: tabs ---------- */
  const places = {
    door: {
      img: "assets/setup-door.jpg",
      alt: "Nordbelt bevestigd onder een stevige deur",
      index: "01 / DEUR",
      title: "Onder een stevige, gesloten deur",
      copy: "Plaats de ankerdelen aan de andere zijde van de deur, sluit hem volledig en controleer de bevestiging vóór je start.",
      safety: "Deur volledig gesloten en stabiel",
    },
    bench: {
      img: "assets/setup-bench.jpg",
      alt: "Nordbelt bevestigd aan een fitnessbank in de gym",
      index: "02 / FITNESSBANK",
      title: "Aan een zware fitnessbank",
      copy: "Sla de band om het frame van een stevige bank, klik de gesp vast en houd de band strak aangetrokken.",
      safety: "Bank stabiel en zwaar genoeg",
    },
    fence: {
      img: "assets/setup-fence.jpg",
      alt: "Nordbelt bevestigd aan een stevig hek langs het sportveld",
      index: "03 / HEK OF BALK",
      title: "Aan een stevig hek of lage balk",
      copy: "Bevestig de lussen laag aan een vast hek of een stevige balk langs het veld en controleer of alles muurvast zit.",
      safety: "Anker muurvast in de grond",
    },
  };
  const placeBtns = $$("[data-place]");
  const placeStage = $(".places__stage");
  if (placeBtns.length && placeStage) {
    const img = $("[data-place-img]", placeStage);
    const idxEl = $("[data-place-index]", placeStage);
    const titleEl = $("[data-place-title]", placeStage);
    const copyEl = $("[data-place-copy]", placeStage);
    const selectPlace = (btn) => {
      const data = places[btn.dataset.place];
      if (!data) return;
      placeBtns.forEach((b) => {
        b.classList.toggle("is-active", b === btn);
        b.setAttribute("aria-selected", String(b === btn));
      });
      placeStage.classList.add("is-swapping");
      const done = () => {
        idxEl.textContent = data.index;
        titleEl.textContent = data.title;
        copyEl.textContent = data.copy;
        placeStage.classList.remove("is-swapping");
      };
      const next = new Image();
      next.onload = () => {
        img.src = data.img;
        img.alt = data.alt;
        done();
      };
      next.onerror = done;
      next.src = data.img;
    };

    let placeTimer = null;
    let placeAuto = true;
    const stopPlaceAuto = () => {
      placeAuto = false;
      if (placeTimer) {
        window.clearInterval(placeTimer);
        placeTimer = null;
      }
    };
    placeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        stopPlaceAuto(); // gebruiker neemt het over
        selectPlace(btn);
      });
    });
    if (!reduceMotion) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting && placeAuto && !placeTimer) {
              placeTimer = window.setInterval(() => {
                const cur = placeBtns.findIndex((b) => b.classList.contains("is-active"));
                selectPlace(placeBtns[(cur + 1) % placeBtns.length]);
              }, 4600);
            } else if (!e.isIntersecting && placeTimer) {
              window.clearInterval(placeTimer);
              placeTimer = null;
            }
          });
        },
        { threshold: 0.35 }
      ).observe(placeStage);
    }
  }


  /* ---------- vergelijking (mobiel): duel-toggle ---------- */
  const duel = $("[data-duel]");
  if (duel) {
    const duelData = {
      bench: {
        foot: "Nordic bench · hogere aanschaf",
        vals: ["yes", "no", "no", "mid", "yes"],
      },
      partner: {
        foot: "Trainingspartner · gratis, als die er is",
        vals: ["no", "dash", "mid", "mid", "no"],
      },
    };
    const glyph = { yes: "✓", no: "✗", mid: "±", dash: "—" };
    const cells = $$("[data-duel-cell]", duel);
    const footEl = $("[data-duel-foot]", duel);
    const colLabel = $("[data-duel-collabel]", duel);
    const opts = $$("[data-duel-opt]", duel);
    const setDuel = (key) => {
      const d = duelData[key];
      if (!d) return;
      opts.forEach((o) => {
        const on = o.dataset.duelOpt === key;
        o.classList.toggle("is-active", on);
        o.setAttribute("aria-selected", String(on));
      });
      cells.forEach((c, i) => {
        c.textContent = glyph[d.vals[i]];
        c.className = "duel__val " + d.vals[i];
      });
      footEl.textContent = d.foot;
      if (colLabel) colLabel.textContent = key === "bench" ? "Bench" : "Partner";
      duel.classList.remove("is-switch");
      void duel.offsetWidth; // herstart de wisselanimatie
      duel.classList.add("is-switch");
    };
    let duelAuto = true;
    let duelTimer = null;
    const stopDuelAuto = () => {
      duelAuto = false;
      if (duelTimer) {
        window.clearInterval(duelTimer);
        duelTimer = null;
      }
    };
    opts.forEach((o) => o.addEventListener("click", () => {
      stopDuelAuto(); // gebruiker neemt het over
      setDuel(o.dataset.duelOpt);
    }));
    setDuel("bench");
    if (!reduceMotion) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting && duelAuto && !duelTimer) {
              duelTimer = window.setInterval(() => {
                const cur = opts.findIndex((x) => x.classList.contains("is-active"));
                setDuel(opts[(cur + 1) % opts.length].dataset.duelOpt);
              }, 5000);
            } else if (!e.isIntersecting && duelTimer) {
              window.clearInterval(duelTimer);
              duelTimer = null;
            }
          });
        },
        { threshold: 0.4 }
      ).observe(duel);
    }
  }

  /* ---------- hotspots (touch) ---------- */
  $$("[data-hotspot]").forEach((h) => {
    h.addEventListener("click", () => {
      const open = h.getAttribute("aria-expanded") === "true";
      $$("[data-hotspot]").forEach((x) => x.setAttribute("aria-expanded", "false"));
      h.setAttribute("aria-expanded", String(!open));
    });
  });

  /* ---------- marquees (reviews + filmstrip): naadloze loop ---------- */
  if (!reduceMotion) {
    $$("[data-marquee-row]").forEach((row) => {
      const set = row.firstElementChild;
      if (!set) return;
      const clone = set.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      row.appendChild(clone);
    });
  }

  /* ---------- productgalerij in de kit ---------- */
  const gallery = $("[data-gallery]");
  if (gallery) {
    const main = $("[data-gal-main]", gallery);
    const hotspots = $$("[data-gal-hotspot]", gallery);
    const countEl = $("[data-gal-count]", gallery);
    const thumbs = $$(".gallery__thumbs button");
    let galIdx = 0;
    const showGal = (idx) => {
      if (idx === galIdx) return;
      const btn = thumbs[idx];
      galIdx = idx;
      thumbs.forEach((b, j) => b.classList.toggle("is-active", j === idx));
      gallery.classList.add("is-swapping");
      const next = new Image();
      const apply = () => {
        main.src = btn.dataset.gal;
        main.alt = btn.dataset.galAlt || "";
        if (countEl) countEl.textContent = String(idx + 1);
        // hotspots horen alleen bij de eerste (baan)foto
        hotspots.forEach((h) => { h.hidden = idx !== 0; });
        gallery.classList.remove("is-swapping");
      };
      next.onload = apply;
      next.onerror = apply;
      next.src = btn.dataset.gal;
    };
    thumbs.forEach((btn, idx) => btn.addEventListener("click", () => showGal(idx)));
    // klik op de grote foto = volgende
    main.addEventListener("click", () => showGal((galIdx + 1) % thumbs.length));
  }

  /* ---------- scroll-to knoppen ---------- */
  $$("[data-scroll-to]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const el = $(btn.dataset.scrollTo);
      if (el) el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" });
    });
  });

  /* ---------- sticky buybar (mobiel) + buy-dock (desktop) ---------- */
  const buybar = $("[data-buybar]");
  const dock = $("[data-dock]");
  const hero = $("[data-hero]");
  if (hero && (buybar || dock)) {
    let heroVis = true;
    let moveVis = false;
    let idleTimer = null;
    const applyDock = () => {
      if (dock) dock.hidden = heroVis || moveVis;
    };
    // mobiele koopbalk: pas tonen wanneer de gebruiker ±1,3s niets doet
    const hideBuybar = () => { if (buybar) buybar.hidden = true; };
    const queueBuybar = () => {
      if (!buybar) return;
      window.clearTimeout(idleTimer);
      hideBuybar();
      idleTimer = window.setTimeout(() => {
        const heroGone = hero.getBoundingClientRect().bottom <= 0;
        if (heroGone && !(cart && cart.open)) buybar.hidden = false;
      }, 1300);
    };
    ["scroll", "touchstart", "pointerdown", "keydown"].forEach((ev) =>
      window.addEventListener(ev, queueBuybar, { passive: true })
    );
    new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { heroVis = e.isIntersecting; });
        applyDock();
        queueBuybar();
      },
      { threshold: 0.05 }
    ).observe(hero);
    if (move) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => { moveVis = e.isIntersecting; });
          applyDock();
        },
        { threshold: 0.01 }
      ).observe(move);
    }
    queueBuybar();
  }

  /* ---------- confetti bij toevoegen ---------- */
  const confettiColors = ["#3959ff", "#8bb8ff", "#ff5a24", "#f4f3ed"];
  const burstConfetti = (x, y) => {
    if (reduceMotion) return;
    for (let i = 0; i < 16; i += 1) {
      const bit = document.createElement("span");
      bit.className = "confetti-bit";
      bit.style.left = `${x}px`;
      bit.style.top = `${y}px`;
      bit.style.background = confettiColors[i % confettiColors.length];
      bit.style.setProperty("--dx", `${(Math.random() - 0.5) * 240}px`);
      bit.style.setProperty("--dy", `${-40 - Math.random() * 160}px`);
      bit.style.setProperty("--rot", `${(Math.random() - 0.5) * 540}deg`);
      document.body.appendChild(bit);
      window.setTimeout(() => bit.remove(), 900);
    }
  };

  /* ---------- concept cart (volledig lokaal) ---------- */
  const cart = $("[data-cart]");
  const cartView = $("[data-cart-view]");
  const cartDone = $("[data-cart-done]");
  const qtyValue = $("[data-qty-value]");
  const addon = $("[data-addon]");
  const totalEl = $("[data-cart-total]");
  const linePrice = $("[data-line-price]");
  const lineOld = $("[data-line-old]");
  const toast = $("[data-toast]");
  let qty = 1;
  let toastTimer = null;

  let commerce = window.NB_CONCEPT_COMMERCE || {};
  if (!Number(commerce.priceCents)) {
    try { commerce = JSON.parse((document.querySelector("[data-nb-concept-commerce]") || {}).textContent || "{}"); } catch (_error) { commerce = {}; }
  }
  const commerceCurrency = commerce.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "";
  const commerceMoney = commerceCurrency
    ? new Intl.NumberFormat(commerce.locale || document.documentElement.lang || "nl-NL", { style: "currency", currency: commerceCurrency })
    : null;
  const euro = (cents) => commerceMoney ? commerceMoney.format((Number(cents) || 0) / 100) : ((Number(cents) || 0) / 100).toFixed(2);
  const unitPriceCents = Number(commerce.priceCents) || 0;
  const unitCompareCents = Number(commerce.compareCents) || unitPriceCents;
  const unitSavingCents = Math.max(0, unitCompareCents - unitPriceCents);
  const addonPriceCents = Number(commerce.addonPriceCents) || 0;
  const saveEl = $("[data-cart-save]");
  const checkoutTotalEl = $("[data-checkout-total]");
  const renderCart = () => {
    qtyValue.textContent = String(qty);
    linePrice.textContent = euro(unitPriceCents * qty);
    lineOld.textContent = euro(unitCompareCents * qty);
    lineOld.hidden = unitCompareCents <= unitPriceCents;
    const total = euro((unitPriceCents * qty) + (addon.checked ? addonPriceCents : 0));
    totalEl.textContent = total;
    if (checkoutTotalEl) checkoutTotalEl.textContent = total;
    if (saveEl) saveEl.textContent = euro(unitSavingCents * qty);
  };

  const showToast = () => {
    toast.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      toast.hidden = true;
    }, 2600);
  };

  const openCart = (e) => {
    if (e && e.clientX) burstConfetti(e.clientX, e.clientY);
    cartDone.hidden = true;
    cartView.hidden = false;
    renderCart();
    if (!cart.open) cart.showModal();
    document.body.style.overflow = "hidden";
    showToast();
  };

  $$("[data-buy]").forEach((btn) => btn.addEventListener("click", openCart));
  $$("[data-cart-close]").forEach((btn) => btn.addEventListener("click", () => cart.close()));
  cart.addEventListener("close", () => {
    document.body.style.overflow = "";
  });
  cart.addEventListener("click", (e) => {
    if (e.target === cart) cart.close();
  });

  $("[data-qty-minus]").addEventListener("click", () => {
    qty = clamp(qty - 1, 1, 5);
    renderCart();
  });
  $("[data-qty-plus]").addEventListener("click", () => {
    qty = clamp(qty + 1, 1, 5);
    renderCart();
  });
  addon.addEventListener("change", renderCart);

  $("[data-checkout]").addEventListener("click", () => {
    cartView.hidden = true;
    cartDone.hidden = false;
  });

  /* ---------- jaar ---------- */
  const yearEl = $("[data-year]");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  /* ---------- subtiele voortgangslijn ---------- */
  const progress = $("[data-scroll-progress]");
  if (progress) {
    const updateProgress = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const value = max > 0 ? clamp(window.scrollY / max, 0, 1) : 0;
      progress.style.transform = `scaleX(${value})`;
    };
    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);
  }
})();
